var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylist02B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "40px",
    viewBox: "0 0 50 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Modul_Playlist_Playlist-02b__Modul/Playlist/Playlist-02b",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Modul_Playlist_Playlist-02b__Group",
    transform: "translate(13 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Playlist-02b__Rectangle",
    fillOpacity: 0.1,
    d: "M-1.27897692e-13 0 19.3649414-1.0658141e-14 24 4.86390187 24 32-1.27897692e-13 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Playlist-02b__Rectangle-Copy-2",
    d: "M3 11 21 11 21 12 3 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Playlist-02b__Rectangle-Copy-3",
    d: "M3 14 21 14 21 15 3 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Playlist-02b__Rectangle-Copy-4",
    d: "M3 17 21 17 21 18 3 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Playlist-02b__Path",
    fillOpacity: 0.1,
    d: "M24 5.47119141 18.6367188 5.47119141 18.6367188 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist02B);
export default __webpack_public_path__ + "static/media/Playlist-02b.5931fe3e8b5d38b2d6329b6d8e11be29.svg";
export { ForwardRef as ReactComponent };